import { useTranslation } from 'react-i18next';

export function TotpInput({ otp, saveOtp, err }) {
  let { t } = useTranslation();

  return (
    <div>
      {t('instructions_2fa_2')}
      <div style={{ display: 'flex', 'justify-content': 'center', 'margin-top': '2rem' }}>
        <div style={{ display: 'flex', 'flex-direction': 'column' }}>
          {err && <span style={{ color: 'red' }}>{t('otp_invalid')}</span>}
          <input
            type="number"
            value={otp}
            onChange={saveOtp}
            style={{ 'font-size': '2rem', 'font-weight': 'bold', padding: '1rem', width: '12rem' }}
            max="999999"
          />
        </div>
      </div>
    </div>
  );
}
